import React, { useMemo, useCallback } from 'react'
import { useIxTheme } from 'contexts/theme-context'
import { DrawerState } from 'helpers/drawer-state-enum'

export const LogoImg = ({ drawerState }: any) => {
    const { currentTheme }: any  = useIxTheme()

    const nonStandardImgSrc = useMemo(() => (
        {
            'material.blue.dark.compact': `/images/V-white.svg`
        } as any
    ),[])

    const handleStyle = useCallback((closedStyle: any, compactStyle: any, openStyle: any) => {
        const style = {
            [DrawerState.Closed]: closedStyle,
            [DrawerState.Compact]: compactStyle,
            [DrawerState.Open]: openStyle,
        } as any

        return style[drawerState]

    },[drawerState])

    return (
        <a
            href='https://www.crem-solutions.de/'
            target='_blank' rel="noreferrer"
            style={{width: handleStyle('30px','50px', '100px'), margin: handleStyle('8px 0 3px 10px', '0 0 10px 10px', '20px 5px 20px 30px')}}>
            <img src={nonStandardImgSrc[currentTheme]||'/images/V-pink.svg'} alt='CremSolutions-Icon' width={ handleStyle(30,  50, 100)}/>
        </a>
    )

}
